import get from 'lodash/get';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { hasCookieBannerEnabled } from '@components/CookieBanner/shared/utils';

import { withData } from '@services/surveyDataProvider';

import LanguageDropdown from './LanguageDropdown';

export const mapSurveyDataToProps = (surveyData) => ({
  enabled: hasCookieBannerEnabled(surveyData)
});

export const mapStateToProps = (state, { enabled }) => ({
  isCookieBannerOpened: enabled && state.cookieBanner.isOpen,
  isRTL: get(state, ['pageSettings', 'isRTL'])
});

const composedConnect = compose(withData(mapSurveyDataToProps), connect(mapStateToProps));

export default composedConnect(LanguageDropdown);
